module.exports = __webpack_public_path__ + "img/p2.f64f6c8b.jpg";